import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'

interface Props {
  deliveryInfo: Record<string, string | null>
}

const OrderDelivery = (props: Props) => {
  const { deliveryInfo } = props
  const { t } = useTranslation()
  const deliveryField: Record<string, string> = {
    name: t('deliveryField.name'),
    email: t('deliveryField.email'),
    address1: t('deliveryField.address1'),
    phone: t('deliveryField.phone'),
    note: t('deliveryField.note'),
  }
  return (
    <VStack width="100%" p={4} gap={2} backgroundColor={colors.white}>
      <Text variant="h5">{t('orderDelivery.recipientInformation')}</Text>
      <VStack>
        {Object.keys(deliveryInfo).map((key) => {
          return (
            <div key={key}>
              <HStack flexWrap="nowrap">
                <Text noWrap>{`${deliveryField[key]}：`}</Text>
                <Text>
                  {deliveryInfo[key] || t('orderDelivery.none')}
                </Text>
              </HStack>
            </div>
          )
        })}
      </VStack>
    </VStack>
  )
}
export default OrderDelivery
